<template>
  <!-- Affichage conditionnel selon la maintenance -->
  <MaintenancePage v-if="shouldShowMaintenancePage" />
  
  <!-- Flux normal de l'application -->
  <template v-else>
    <MainLayout v-if="authStore.isAuthenticated">
      <RouterView />
    </MainLayout>
    <RouterView v-else />

    <!-- Barre de dev pour super admin -->
    <DevRoleBar v-if="authStore.isAuthenticated" />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { RouterView } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import MainLayout from '@/components/layout/MainLayout.vue'
import DevRoleBar from '@/components/dev/DevRoleBar.vue'
import MaintenancePage from '@/pages/MaintenancePage.vue'
import { maintenanceEnabled } from '@/stores/maintenance'

const authStore = useAuthStore()
const route = useRoute()

// Routes publiques (accessibles même en maintenance)
// Le login n'en fait pas partie : en maintenance, la page dédiée porte son propre formulaire de connexion
const PUBLIC_ROUTES = ['reset-password', 'new-password', 'not-found']

const shouldShowMaintenancePage = computed(() => {
  // Si la maintenance n'est pas activée, ne jamais afficher la page
  if (!maintenanceEnabled.value) return false
  
  // Si l'utilisateur est sur une route publique, ne pas afficher la maintenance
  const routeName = route.name as string
  if (PUBLIC_ROUTES.includes(routeName)) return false
  
  // Si l'utilisateur n'est pas authentifié, afficher la maintenance
  if (!authStore.isAuthenticated) return true
  
  // Si l'utilisateur est authentifié mais n'est pas super admin, afficher la maintenance
  const isSuperAdmin = authStore.user?.roles?.is_super_admin ?? false
  return !isSuperAdmin
})
</script>
